const allowedOAuthOrigins = [
    'https://raviremmi.com',
    'https://www.raviremmi.com',
];
const browserOrigin = typeof window !== 'undefined' ? window.location.origin : '';
const oauthOrigin = allowedOAuthOrigins.includes(browserOrigin)
    ? browserOrigin
    : allowedOAuthOrigins[0];

const awsmobile = {
    Auth: {
        region: 'eu-north-1',
        userPoolId: 'eu-north-1_AxuLEcS3a',
        userPoolWebClientId: '5cev82k9sf0a1ooo9a14r1a1ju',
        authenticationFlowType: 'USER_PASSWORD_AUTH',
        oauth: {
            domain: 'raviremmi-prod-720309307349.auth.eu-north-1.amazoncognito.com',
            scope: ['openid', 'email', 'profile'],
            redirectSignIn: `${oauthOrigin}/auth/callback`,
            redirectSignOut: `${oauthOrigin}/`,
            responseType: 'code',
        },
    }
};

export default awsmobile;
